import { IAppState } from "../../../app/appTypes"
import { ILiveMeetingConfigState } from "../../../features/liveMeeting/state/liveMeetingTypes"

export const getLiveMeetingConfig = (state: IAppState): ILiveMeetingConfigState => state.liveMeetingConfig
